'use client'

import * as React from 'react'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from 'next-themes'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

interface ThemeToggleProps {
  className?: string
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme()
  const [mounted, setMounted] = React.useState(false)

  React.useEffect(() => {
    setMounted(true)
  }, [])

  const isDark = mounted && resolvedTheme === 'dark'
  const label = mounted
    ? isDark
      ? 'Cambiar a modo claro'
      : 'Cambiar a modo oscuro'
    : 'Cambiar tema'

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className={cn('text-foreground/70 hover:text-primary relative', className)}
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={label}
      aria-pressed={mounted ? isDark : false}
      disabled={!mounted}
    >
      <Sun
        className="size-4 transition-opacity duration-200 ease-out"
        aria-hidden
        style={{ opacity: mounted ? (isDark ? 0 : 1) : 1 }}
      />
      <Moon
        className="absolute size-4 transition-opacity duration-200 ease-out"
        aria-hidden
        style={{ opacity: mounted ? (isDark ? 1 : 0) : 0 }}
      />
    </Button>
  )
}
